
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'SimpleCard',

  props: {
    image: String,
    imageAlt: {
      type: String,
      default: ''
    },
    category: String,
    heading: String,
    description: String,
    url: String,
    mini: {
      type: Boolean,
      default: false
    },
    isList: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      default: '/'
    }
  },

  setup(props) {
    const router = useRouter()

    const clickA = (e: any) => {
      if (props.url) return true
      if (e.ctrlKey || e.metaKey) return true

      e.preventDefault()
      return router.push(props.path)
    }

    return {
      clickA
    }
  }
})
